import { UsersService } from '../services';
import { usersKeys } from '../queryKeys';
import { useUsersPageQuery } from './useUsersPageQuery';

/** The page size every list here uses; organization-service's own default is 50. */
export const IDENTITY_LOCATIONS_PAGE_SIZE = 15;

/**
 * A page of the locations one identity can access, for the Location User
 * profile's Locations tab.
 *
 * Search is organization-service's, on the location name: some identities
 * reach more than a thousand locations, so the tab cannot filter a list it
 * holds. organization-service trims `q` itself; trimming it here as well keeps
 * "smile " and "smile" on one cache entry, as they are one request.
 *
 * The tab renders the failure itself, so the global toaster stays off.
 *
 * @param {string} [identityId]
 * @param {Object} [params]
 * @param {number} [params.page=1] - 1-based page.
 * @param {string} [params.q=''] - The search box value, as settled.
 */
export const useGetIdentityLocations = (identityId, { page = 1, q = '' } = {}) => {
  const search = q.trim();

  const { rows, ...query } = useUsersPageQuery(
    usersKeys.locationUserLocations(identityId, search, page),
    () =>
      UsersService.getIdentityLocations({
        identityId,
        q: search,
        page,
        limit: IDENTITY_LOCATIONS_PAGE_SIZE,
      }),
    IDENTITY_LOCATIONS_PAGE_SIZE,
    {
      enabled: Boolean(identityId),
      refetchOnWindowFocus: false,
      meta: { skipGlobalErrorToaster: true },
    },
  );

  return { locations: rows, ...query };
};
